export const formatFilePath = (path: string) => {
  return path.split(`\\`).join(`/`);
};